import { Check, Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

import { useApiMutation } from "~/hooks/useApiMutation";
import { selectUser, type UserData } from "~/store";

const FIRST_STEPS: { title: string }[] = [
  {
    title: "Creación de perfiles: Usuario y Empresa",
  },
  {
    title: "Agendar llamada de bienvenida con tu analista financiero",
  },
  {
    title: "Carga de datos",
  },
  {
    title: "Procesamiento y análisis de información inicial",
  },
  {
    title: "Agendar llamada de validación de modelo financiero",
  },
  {
    title: "Acceso al tablero de resumen y screeners",
  },
];

interface FirstStepsModalProps {
  open: boolean;
  onClose: () => void;
}

export function FirstStepsModal({ open, onClose }: FirstStepsModalProps) {
  const user = useSelector(selectUser);

  const { mutate: updateUser, isPending: isUpdatingUser } = useApiMutation<
    Partial<UserData>,
    UserData
  >(
    `/api/v1/users/${user?.id}`,
    {
      onSuccess: () => {
        onClose();
      },
    },
    "put",
  );

  const handleDismiss = () => {
    updateUser({
      showFirstSteps: false,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === "escapeKeyDown" || reason === "backdropClick") return;
        onClose();
      }}
      disableEscapeKeyDown
      sx={{
        ".MuiDialog-paper": {
          maxWidth: "445px",
          p: 0,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="body1" color="primary.main">
          Primeros pasos
        </Typography>
        <IconButton
          disabled
          sx={{
            position: "absolute",
            right: 10,
            top: 10,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack gap="20px">
          <Typography variant="body2">
            Para convertir tu contabilidad en finanzas reales vamos a continuar
            con los pasos siguientes:
          </Typography>

          <Stack gap="20px">
            {FIRST_STEPS.map((step, index) => (
              <Stack direction="row" key={index} gap={0.5}>
                <Check
                  color="primary"
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                />

                <Typography variant="body2">{step.title}</Typography>
              </Stack>
            ))}
          </Stack>

          <Typography variant="body2">
            Bienvenido
            <br />
            -El equipo de Monthly
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={handleDismiss}
          loading={isUpdatingUser}
        >
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
